// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-message-item {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  padding: 5px 20px;
}
.chat-message-item.myself {
  flex-direction: row-reverse;
}
.chat-message-item.myself .chat-message-avatar {
  margin-right: 0;
  margin-left: 16px;
}
.chat-message-item .chat-message-avatar {
  width: 50px;
  height: 50px;
  color: #333;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}
.chat-message-item .chat-message-avatar .chat-message-avatar-img {
  width: 26px;
  height: 26px;
  border-radius: 6px;
}
.chat-message-item .chat-message-content {
  flex-grow: 1;
}
.chat-message-item .chat-message-content .chat-message-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.chat-message-item .chat-message-content .chat-message-info.myself {
  flex-direction: row-reverse;
}
.chat-message-item .chat-message-content .chat-message-info.myself .chat-message-receiver {
  text-align: right;
}
.chat-message-item .chat-message-content .chat-message-info .chat-message-receiver {
  flex-grow: 1;
  text-align: left;
}
.chat-message-item .chat-message-content .chat-message-info .chat-message-receiver > span {
  margin: 0 5px;
  color: #ccc;
}
.chat-message-item .chat-message-content .chat-message-info .chat-message-receiver > a {
  text-decoration: none;
  color: #2da5ff;
}
.chat-message-item .chat-message-content .chat-message-info .chat-message-time {
  max-width: 100px;
  color: #ccc;
}
.chat-message-item .chat-message-content .chat-message-text-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.chat-message-item .chat-message-content .chat-message-text-list .chat-message-text {
  padding: 8px 10px;
  border-radius: 8px;
  background: rgba(82, 82, 128, 0.09);
  color: #333;
  font-size: 13px;
  margin-bottom: 8px;
}
.chat-message-item .chat-message-content .chat-message-text-list.myself {
  align-items: flex-end;
}
.chat-message-item .chat-message-content .chat-message-text-list.myself .chat-message-text {
  background: #deedfd;
}`, "",{"version":3,"sources":["webpack://./src/feature/chat/component/chat-message-item.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;AACF;AAAE;EACE,2BAAA;AAEJ;AADI;EACE,eAAA;EACA,iBAAA;AAGN;AAAE;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAEJ;AADI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAGN;AAAE;EACE,YAAA;AAEJ;AADI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAGN;AAFM;EACE,2BAAA;AAIR;AAHQ;EACE,iBAAA;AAKV;AAFM;EACE,YAAA;EACA,gBAAA;AAIR;AAHQ;EACE,aAAA;EACA,WAAA;AAKV;AAHQ;EACE,qBAAA;EACA,cAAA;AAKV;AAFM;EACE,gBAAA;EACA,WAAA;AAIR;AADI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAGN;AAFM;EACE,iBAAA;EACA,kBAAA;EACA,mCAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAIR;AAFM;EACE,qBAAA;AAIR;AAHQ;EACE,mBAAA;AAKV","sourcesContent":[".chat-message-item{\n  align-items: flex-start;\n  display: flex;\n  justify-content:space-between ;\n  margin-bottom: 15px;\n  padding: 5px 20px;\n  &.myself{\n    flex-direction: row-reverse;\n    .chat-message-avatar {\n      margin-right: 0;\n      margin-left: 16px;\n    }\n  }\n  .chat-message-avatar {\n    width: 50px;\n    height: 50px;\n    color: #333;\n    font-size: 22px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 16px;\n    .chat-message-avatar-img {\n      width: 26px;\n      height: 26px;\n      border-radius: 6px;\n    }\n  } \n  .chat-message-content{\n    flex-grow: 1;\n    .chat-message-info{\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      &.myself{\n        flex-direction: row-reverse;\n        .chat-message-receiver {\n          text-align: right;\n        }\n      }\n      .chat-message-receiver {\n        flex-grow: 1;\n        text-align: left;\n        >span {\n          margin:0 5px;\n          color: #ccc;\n        }\n        >a {\n          text-decoration: none;\n          color: #2da5ff;\n        }\n      }\n      .chat-message-time {\n        max-width: 100px;\n        color: #ccc;\n      }\n    }\n    .chat-message-text-list {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      .chat-message-text {\n        padding: 8px 10px;\n        border-radius: 8px;\n        background: rgba(82,82,128,0.09);\n        color: #333;\n        font-size: 13px;\n        margin-bottom: 8px;\n      }\n      &.myself {\n        align-items: flex-end;\n        .chat-message-text {\n          background: #deedfd;\n        }\n      }\n\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
